module.exports = __webpack_public_path__ + "img/arw-left.4784b85d.svg";